import './SmartFarm.css';

function SrvSmartFarm() {
  const smartItems = [
    { title: '제어항목', value: '온도, 습도, EC, PH, 조도, 환기, 냉난방 제어' },
    { title: '통신방식', value: '유선(RS485, RS232), 무선(Wi-Fi, Bluetooth)' },
    { title: '센서종류', value: '온습도센서, 토양센서, 전력계, 수도계량기 등' },
    { title: '제어장비', value: '히터, 팬, 에어컨, 조명, 펌프, 인버터, 밸브, 어닝, 창문 모터 등' },
    { title: '모니터링', value: '웹/모바일 원격 제어, 알람 기능, 이력 조회' },
    { title: '시스템구성', value: '센서 → 제어기 → 서버 → 사용자 인터페이스' },
    { title: '주요특징', value: '전용제어기, 사용자 맞춤 자동화 프로그램' },
    { title: '적용', value: <>업소용 채소재배기[도시형 스마트팜]<br />안개분무 시스템[온습도제어, 악취제거]<br />이끼(MOSS) 재배기<br />
    사료공급기[돈사 스마트팜]<br />유리온실, 식물원 환경관리[냉난방, 환기, 어닝]</> }
  ];

  const sfplcItems = [
    { title: 'Microprocessor', value: '32bit 72MHz / EEPROM 32K' },
    { title: 'Digital Input', value: '2 points, Level switch(High/Low)' },
    { title: 'Analog Input', value: '3 points, 4-20mA (Temperature/Humidity/Water Pressure)' },
    { title: 'Inverter Interface', value: <>DI1(ALARM), DO1(RUN), RS485(SET)<br /><br />Applied Interfaces : <br />G100/G100C/iG5A [LS ELECTRIC] </> },
    { title: 'EC/PH Interface', value: <>RS485, UART TTL<br /><br />Applied Interfaces : <br />PH3178 [HEDAO - China]<br />KCD-PE350 [KOREADIGITIAL - Korea]<br />SOIL SENSOR [Halisense - China]</> },
    { title: 'AC Output', value: '15A 2 points, 5A 8 points' },
    { title: 'HMI', value: <>RS232, UART TTL<br /><br />Applied Interfaces : <br />easyview [Weintek - Taiwan]<br />Nextion [ITEAD Intelligent Systems - China]</> },
    { title: 'Remote Control', value: 'Wifi API & Bluetooth interface' },
    { title: 'Dimensions', value: '160 x 95 x 55 mm (W x H x D)' }
  ];

  return (
    <div className="overview-container">
      {/* ✅ 제목은 페이지 최상단 */}
      <div className="section-title-box">스마트팜 환경제어</div>


      {/* 상단: 이미지 + 설명 */}
      <div className="smartfarm-header">
        <div className="smartfarm-image">
          <img src="/images/smartfarm_plc.jpg" alt="스마트팜 대표 이미지" />
        </div>
        <div className="smartfarm-text">
          <p>
            <>스마트팜 환경제어 시스템은 다양한 센서와 제어기를 통해 작물에 최적화된
            환경을 유지하며, 원격으로 모니터링하고 자동화할 수 있는 통합 제어 솔루션입니다.<br />
            <b>전용제어기</b>를 사용하여, 기술보안 강화/생산속도 향상/소형화/모터제어 등 PLC구현이 어려운 기능지원/
            외부리스크저감 - 공급부족, 단가상승 등/생산비용 절감 의 효과를 기대할 수 있습니다.</>
          </p>
        </div>
      </div>

      {/* 하단 콘텐츠: 기존 테이블 */}
      <div className="overview-table">
        {smartItems.map((item, index) => (
          <div key={index} className="overview-row">
            <div className="overview-title">{item.title}</div>
            <div className="overview-value">{item.value}</div>
          </div>
        ))}
      </div>

      <div className="section-title-box">전용제어기 [XAutoCon-M1-SF]</div>
      <div className="smartfarm-header">
        <div className="smartfarm1-image">
            <img src="/images/XAutoCon_M1_SF.jpg" alt="XAutoCon-M1-SF" />
        </div>
      </div>
      {/* 하단 콘텐츠: 기존 테이블 */}
      <div className="overview-table">
        {sfplcItems.map((item, index) => (
          <div key={index} className="overview-row">
            <div className="overview-title">{item.title}</div>
            <div className="overview-value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SrvSmartFarm;
